import type { ReactNode } from 'react';

export const symbol_task: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m434-333-84-84q-4.11-4-8.91-6t-9.95-2q-5.14 0-10.14 2.25-5 2.25-9 6.75-8 8.27-8 19.63 0 11.37 8 19.37l101 101q5 5 10.13 7 5.14 2 11 2 5.87 0 10.87-2 5-2 10-7l189-189q8-8.09 8-19.54 0-11.46-8.07-19.46t-19.5-8Q613-512 605-504L434-333ZM220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h336q12.44 0 23.72 5T599-862l183 183q8 8 13 19.28 5 11.28 5 23.72v496q0 24-18 42t-42 18H220Zm331-584v-156H220v680h520v-494H581q-12.75 0-21.37-8.63Q551-651.25 551-664ZM220-820v186-186 680-680Z"
		/>
	</svg>
);
